import {
  common as commonEn,
  projectHome as projectHomeEn,
  createProject as createProjectEn,
  settings as settingsEn,
  projects as projectsEn
} from "./locales/en";
import {
  common as commonJa,
  projectHome as projectHomeJa,
  createProject as createProjectJa,
  settings as settingsJa,
  projects as projectsJa
} from "./locales/ja";

export const defaultNS = "common";

export const resources = {
  en: {
    common: commonEn,
    projectHome: projectHomeEn,
    createProject: createProjectEn,
    settings: settingsEn,
    projects: projectsEn
  },
  ja: {
    common: commonJa,
    projectHome: projectHomeJa,
    createProject: createProjectJa,
    settings: settingsJa,
    projects: projectsJa
  }
} as const;

export type TAppResources = (typeof resources)["en"];
